import type {CapacityCombined} from '@/types/CapacityCombined';
import type {CapacityLabel} from '@/types/CapacityLabel';

const buildCapacityOverrideTotals = (
    yearMonthsDisplay : string[],
    overrideLabels : CapacityLabel[],
    capacityCombined : CapacityCombined[],
) : Record<string, number> => {
    const userSums : Record<string, number> = {};

    for (let i = 0; i < yearMonthsDisplay.length; i++) {
        const fiscalMonth = yearMonthsDisplay[i];

        if (!userSums[fiscalMonth]) {
            userSums[fiscalMonth] = 0;
        }

        for (const overrideLabel of overrideLabels) {
            const foundCombined = capacityCombined
                .find(combined => combined.timeLabelID === overrideLabel.timeLabelID);

            const totalToAdd = foundCombined ? (foundCombined.hours[i] ?? 0) : 0;

            userSums[fiscalMonth] += totalToAdd;
        }
    }

    return userSums;
};

export default buildCapacityOverrideTotals;
